"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getNestedPropertiesAsStrings = _interopRequireDefault(require("redux-less/utils/getNestedPropertiesAsStrings"));

var _isPropertyChanged = _interopRequireDefault(require("./isPropertyChanged"));

var _default = function _default(_ref) {
  var property = _ref.property,
      currentValue = _ref.currentValue,
      nextValue = _ref.nextValue;
  var nestedPropertiesAsStrings = (0, _getNestedPropertiesAsStrings.default)(property);
  return nestedPropertiesAsStrings.find(function (prop) {
    var path = prop.split("/");
    path.shift();
    return (0, _isPropertyChanged.default)(currentValue.getIn(path), nextValue.getIn(path));
  }) !== undefined;
};

exports.default = _default;
module.exports = exports.default;